module.exports = __webpack_public_path__ + "static/media/coffee-and-book.fe1aed70.svg";